var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0935 12.3551V7.17737H14.0623C14.0623 10.0365 16.3144 12.3551 19.0935 12.3551Z",
    fill: "#232D54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22H11.4443C15.6685 22 19.0934 18.4753 19.0934 14.128H4V22Z",
    fill: "#232D54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0623 2C14.0623 4.85916 16.3143 7.17773 19.0934 7.17773V2H14.0623Z",
    fill: "#232D54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03113 2C9.03113 4.85916 11.2832 7.17773 14.0623 7.17773H9.03113C9.03113 10.0369 11.2832 12.3555 14.0623 12.3555V7.17773V2H9.03113Z",
    fill: "#232D54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03115 12.3551V7.17737H4C4 10.0365 6.25208 12.3551 9.03115 12.3551Z",
    fill: "#232D54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo_mobile.f66957bd68fdc6cc8133575db7b74edb.svg";
export { ForwardRef as ReactComponent };